import React from 'react'
import {
  Wrapper,
  IconWrapper,
  TitleWrapper,
  DescriptionWrapper,
  ButtonWrapper,
} from './component.styles'
import PropTypes from 'prop-types'
import CreateCourse from 'experienceComponents/CreateCourse'

const K8ProgramPrimaryCTA = ({
  bodyCopy,
  buttonLabel,
  contentfulCourses,
  header,
  iconUrl,
  onClick,
  useCase,
}) => {
  const isCreateClass = useCase === 'create_class'

  return (
    <Wrapper isCreateClass={isCreateClass}>
      <IconWrapper>{iconUrl && <img alt="" src={iconUrl} />}</IconWrapper>
      <TitleWrapper isCreateClass={isCreateClass}>{header}</TitleWrapper>
      <DescriptionWrapper>{bodyCopy}</DescriptionWrapper>
      {isCreateClass ? (
        <div style={{ marginTop: '20px' }}>
          <CreateCourse
            contentfulCourses={contentfulCourses}
            emptyClasses={true}
          />
        </div>
      ) : (
        <ButtonWrapper isCreateClass={isCreateClass} onClick={onClick}>
          {buttonLabel}
        </ButtonWrapper>
      )}
    </Wrapper>
  )
}

K8ProgramPrimaryCTA.propTypes = {
  bodyCopy: PropTypes.string,
  buttonLabel: PropTypes.string,
  contentfulCourses: PropTypes.array,
  header: PropTypes.string,
  iconUrl: PropTypes.string,
  onClick: PropTypes.func,
  useCase: PropTypes.string,
}

export default K8ProgramPrimaryCTA
